"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AjvError () {
        return _NcErrorV1.AjvError;
    },
    get NcError () {
        return NcError;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _NcErrorV1 = require("./NcErrorV1");
const _ncErrorV3 = require("./ncErrorV3");
let NcError = class NcError {
    // return ncError based on api version
    static get(context) {
        if ((context == null ? void 0 : context.api_version) === _nocodbsdk.NcApiVersion.V3) {
            return NcError._V3;
        }
        return NcError._;
    }
    // backward compatibility
    /* region statics */ static authenticationRequired(args) {
        return NcError._.authenticationRequired(args);
    }
    static apiTokenNotAllowed(args) {
        return NcError._.apiTokenNotAllowed(args);
    }
    static workspaceNotFound(id, args) {
        return NcError._.workspaceNotFound(id, args);
    }
    static columnAssociatedWithLink(_id, args) {
        return NcError._.columnAssociatedWithLink(_id, args);
    }
    static tableAssociatedWithLink(_id, args) {
        return NcError._.tableAssociatedWithLink(_id, args);
    }
    static baseNotFound(id, args) {
        return NcError._.baseNotFound(id, args);
    }
    static widgetNotFound(id, args) {
        return NcError._.widgetNotFound(id, args);
    }
    static dashboardNotFound(id, args) {
        return NcError._.dashboardNotFound(id, args);
    }
    static viewSectionNotFound(id, args) {
        return NcError._.viewSectionNotFound(id, args);
    }
    static sourceNotFound(id, args) {
        return NcError._.sourceNotFound(id, args);
    }
    static tableNotFound(id, args) {
        return NcError._.tableNotFound(id, args);
    }
    static userNotFound(id, args) {
        return NcError._.userNotFound(id, args);
    }
    static teamNotFound(id, args) {
        return NcError._.teamNotFound(id, args);
    }
    static viewNotFound(id, args) {
        return NcError._.viewNotFound(id, args);
    }
    static hookNotFound(id, args) {
        return NcError._.hookNotFound(id, args);
    }
    static genericNotFound(resource, id, args) {
        return NcError._.genericNotFound(resource, id, args);
    }
    static requiredFieldMissing(field, args) {
        return NcError._.requiredFieldMissing(field, args);
    }
    static duplicateRecord(id, args) {
        return NcError._.duplicateRecord(id, args);
    }
    static fieldNotFound(id, args) {
        return NcError._.fieldNotFound(id, args);
    }
    static invalidOffsetValue(offset, args) {
        return NcError._.invalidOffsetValue(offset, args);
    }
    static invalidPageValue(page, args) {
        return NcError._.invalidPageValue(page, args);
    }
    static invalidPrimaryKey(value, pkColumn, args) {
        return NcError._.invalidPrimaryKey(value, pkColumn, args);
    }
    static invalidLimitValue(args) {
        return NcError._.invalidLimitValue(args);
    }
    static invalidFilter(filter, args) {
        return NcError._.invalidFilter(filter, args);
    }
    static invalidValueForField(payload, args) {
        return NcError._.invalidValueForField(payload, args);
    }
    static invalidSharedViewPassword(args) {
        return NcError._.invalidSharedViewPassword(args);
    }
    static invalidSharedDashboardPassword(args) {
        return NcError._.invalidSharedDashboardPassword(args);
    }
    static invalidAttachmentJson(payload, args) {
        return NcError._.invalidAttachmentJson(payload, args);
    }
    static notImplemented(feature = 'Feature', args) {
        return NcError._.notImplemented(feature, args);
    }
    static internalServerError(message, args) {
        return NcError._.internalServerError(message, args);
    }
    static formulaError(message, args) {
        return NcError._.formulaError(message, args);
    }
    static formulaCircularRefError(message, args) {
        return NcError._.formulaCircularRefError(message, args);
    }
    static unauthorized(message, args) {
        return NcError._.unauthorized(message, args);
    }
    static forbidden(message, args) {
        return NcError._.forbidden(message, args);
    }
    static insufficientPrivilege(message, args) {
        return NcError._.insufficientPrivilege(message, args);
    }
    static sourceDataReadOnly(name) {
        return NcError.forbidden(`Source '${name}' is read-only`);
    }
    static sourceMetaReadOnly(name) {
        return NcError.forbidden(`Source '${name}' schema is read-only`);
    }
    static integrationNotFound(id, args) {
        return NcError._.integrationNotFound(id, args);
    }
    static cannotCalculateIntermediateOrderError() {
        return NcError._.cannotCalculateIntermediateOrderError();
    }
    static reorderFailed() {
        return NcError._.reorderFailed();
    }
    static integrationLinkedWithMultiple(bases, sources, args) {
        return NcError._.integrationLinkedWithMultiple(bases, sources, args);
    }
    static invalidAttachmentUploadScope(args) {
        return NcError._.invalidAttachmentUploadScope(args);
    }
    static planLimitExceeded(message, details, args) {
        return NcError._.planLimitExceeded(message, details, args);
    }
    static allowedOnlySSOAccess(ncWorkspaceId) {
        return NcError._.allowedOnlySSOAccess(ncWorkspaceId);
    }
    static allowedOnlySSOGeneratedToken(ncWorkspaceId) {
        return NcError._.allowedOnlySSOGeneratedToken(ncWorkspaceId);
    }
    static maxPayloadLimitExceeded(limit, args) {
        return NcError._.maxPayloadLimitExceeded(limit, args);
    }
    static baseUserError(message, args) {
        return NcError._.baseUserError(message, args);
    }
    static orgUserError(message, args) {
        return NcError._.orgUserError(message, args);
    }
    static tableError(message, args) {
        return NcError._.tableError(message, args);
    }
    static columnError(message, args) {
        return NcError._.columnError(message, args);
    }
    static maxWorkspaceLimitReached(args) {
        return NcError._.maxWorkspaceLimitReached(args);
    }
    static notFound(message = 'Not found') {
        return NcError._.notFound(message);
    }
    static badRequest(message) {
        return NcError._.badRequest(message);
    }
    static unprocessableEntity(message = 'Unprocessable entity') {
        return NcError._.unprocessableEntity(message);
    }
    static optionsNotExists(props) {
        return NcError._.optionsNotExists(props);
    }
    static testConnectionError(message = 'Unprocessable entity', code) {
        return NcError._.testConnectionError(message, code);
    }
    static notAllowed(message = 'Not allowed') {
        return NcError._.notAllowed(message);
    }
    static emailDomainNotAllowed(domain) {
        return NcError._.emailDomainNotAllowed(domain);
    }
    static metaError(param) {
        return NcError._.metaError(param);
    }
    static permissionDenied(permissionName, roles, extendedScopeRoles) {
        return NcError._.permissionDenied(permissionName, roles, extendedScopeRoles);
    }
    static recordNotFound(id, args) {
        return NcError._.recordNotFound(id, args);
    }
    static ajvValidationError(param) {
        return NcError._.ajvValidationError(param);
    }
    static externalError(message, args) {
        return NcError._.externalError(message, args);
    }
    static externalTimeOut(message, args) {
        return NcError._.externalTimeOut(message, args);
    }
    static pluginTestError(message, args) {
        return NcError._.pluginTestError(message, args);
    }
};
NcError._ = new _NcErrorV1.NcErrorV1();
NcError._V3 = new _ncErrorV3.NcErrorV3();
